/* eslint-disable */
(function ($) {
  $.Redactor.opts.langs.FR = require('transifex/languages/fr.json').redactor;
})(jQuery);
